import {
  type CreateRoomTypeRequest,
  type RoomTypeDetail,
  RoomTypeDetailSchema,
  type RoomTypeListQuery,
  type RoomTypeListResponse,
  RoomTypeListResponseSchema,
  type UpdateRoomTypeRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listRoomTypes = async (query: RoomTypeListQuery): Promise<RoomTypeListResponse> => {
  const { data } = await apiClient.get<unknown>('/room-types', { params: query });
  return RoomTypeListResponseSchema.parse(data);
};

export const getRoomType = async (id: string): Promise<RoomTypeDetail> => {
  const { data } = await apiClient.get<unknown>(`/room-types/${id}`);
  return RoomTypeDetailSchema.parse(data);
};

export const createRoomType = async (payload: CreateRoomTypeRequest): Promise<RoomTypeDetail> => {
  const { data } = await apiClient.post<unknown>('/room-types', payload);
  return RoomTypeDetailSchema.parse(data);
};

export const updateRoomType = async (
  id: string,
  payload: UpdateRoomTypeRequest,
): Promise<RoomTypeDetail> => {
  const { data } = await apiClient.patch<unknown>(`/room-types/${id}`, payload);
  return RoomTypeDetailSchema.parse(data);
};

export const deleteRoomType = async (id: string): Promise<void> => {
  await apiClient.delete(`/room-types/${id}`);
};

export const bulkDeleteRoomTypes = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/room-types/bulk-delete', { ids });
  return data;
};

export const bulkSetRoomTypesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/room-types/bulk-set-status', { ids, isActive });
  return data;
};
